module.exports = __webpack_public_path__ + "static/media/eon.6a7b6a8e.svg";